import ExamResultTitleLayout from './ExamResultTitleLayout';
export default ExamResultTitleLayout;
